import React, { ReactElement } from 'react';

import { Box, Flex } from 'components';
import { ColorsTypes } from 'styled-components';

interface ProgressBarProps {
  percent: number;
  height?: number;
  bulletPercent?: number;
  bgTrack?: ColorsTypes;
  bgBar?: ColorsTypes;
  bgBullet?: ColorsTypes;
}

const ProgressBar = ({
  percent,
  height = 10,
  bulletPercent,
  bgTrack = 'gray_200',
  bgBar = 'primary_400',
  bgBullet = 'gray_100',
}: ProgressBarProps): ReactElement => (
  <Box bg={bgTrack} height={height} borderRadius={height / 2} position="relative">
    {typeof bulletPercent !== 'undefined' && (
      <Flex justifyContent="flex-end" position="absolute" width={`${bulletPercent}%`} height={10}>
        <Box maxWidth={height} height={height} flexShrink={0} bg={bgBullet} borderRadius={height / 2} />
      </Flex>
    )}
    <Box bg={bgBar} width={`${percent}%`} height={height} borderRadius={height / 2} />
  </Box>
);

export default ProgressBar;
